<template>
  <div ><h2>此页面不存在</h2></div>
</template>

<style lang="scss" scoped>
div {
    width: 200px;
    margin: auto;
    padding-top: 200px;
}
</style>